<template>
  <div class="formLogin">
    <a-form-model :model="ruleForm" :rules="isLogin ? rules1 : rules" ref="ruleForm" label-width="0px">
      <a-form-model-item prop="phone">
        <a-input size="large" v-model="ruleForm.phone" placeholder="请输入手机号" allowClear
          oninput="value=value.replace(/[^0-9]/g,'');if(value.length > 11)value = value.slice(0, 11)" />
      </a-form-model-item>
      <div class="captcha">
        <a-form-model-item prop="captcha">
          <a-input size="large" v-model="ruleForm.captcha" type="password" allowClear
            oninput="value=value.replace(/[^0-9]/g,'');if(value.length > 6)value = value.slice(0, 6)"
            placeholder="请输入验证码">
            <a-button slot="addonAfter" class="captchaButton" :disabled="captchaButtonDisabled" @click="getCaptcha">
              {{ captchaBtnContent }} </a-button>
          </a-input>
        </a-form-model-item>

      </div>
      <Environment />
      <Vcode :show="errVcode" @success="successVcode" @close="closeVcode" />
    </a-form-model>
    <a-button class="button" @click="submitForm" :loading="btnLoading">登&nbsp;录</a-button>
  </div>
</template>

<script>
import Vcode from 'vue-puzzle-vcode';
import { message } from 'ant-design-vue';
import { post, get } from '@/utils/http';
// eslint-disable-next-line import/no-unresolved
import { pointTools , traceClick} from '@/utils/point';
import { getLogo } from '@/utils/intConfiguration';
import { isCustomerSaasPrivate } from '@/utils/globalConfig';
import ErrorLogin from '@/utils/errorLogin';
import Environment from '../environment.vue';
import api from '../../../../api/index';
import {
  setToken,
  rmToken,
  obtainUrl,
} from '../../login-handler';
import { pwdPublicKeyEncode } from "@/utils/RSAUtils";

export default {
  name: 'VerificationLogin',
  components: {
    Environment,
    Vcode,
  },
  props:['agree'],
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        phone: '',
        captcha: '',
      },
      rulesPhone: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { pattern: /^1[0-9]{10}$/, message: '手机号码格式不正确', trigger: 'change' },
      ],
      rules: {
        phone: [],
      },
      rules1: {
        phone: [],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^[0-9]{6}$/, message: '验证码格式不正确', trigger: 'change' },
        ],
      },
      isLogin: true, /// 用来判断校验条件
      captchaButtonDisabled: false, /// 获取验证码按钮是否禁用
      totalTime: 60, /// 倒计时
      captchaBtnContent: '获取验证码', // 按钮里显示的内容
      codeId: '', /// 验证码 id
      logoUi: getLogo(),
      errlg: null,
      errVcode: false,
    };
  },

  mounted() {
    this.errlg = new ErrorLogin();
    this.rules.phone = this.rulesPhone;
    this.rules1.phone = this.rulesPhone;
    if (localStorage.getItem('phone')) {
      this.ruleForm.phone = localStorage.getItem('phone');
    }
  },
  watch: {
    'ruleForm.captcha.length': {
      handler() {
        /// 如果已输入验证码，自动转为登录校验
        this.isLogin = this.ruleForm.captcha.length > 0;
      },
    },
  },
  methods: {
    successVcode() {
      this.errVcode = false;
      this.errlg.refreshPasWord(0);
    },
    closeVcode() {
      // this.errVcode = false;
    },
    /// 获取验证码倒计时
    countDown() {
      this.captchaButtonDisabled = true;
      this.captchaBtnContent = `${this.totalTime}s`; // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime -= 1;
        this.captchaBtnContent = `${this.totalTime}s`;
        if (this.totalTime < 0) { // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.captchaBtnContent = '重新获取';
          this.totalTime = 60;
          this.captchaButtonDisabled = false;
        }
      }, 1000);
    },
    /// 获取验证码
    getCaptcha() {
      this.isLogin = false;
      setTimeout(() => {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (!this.errlg.voidCodeLogin(0)) {
              this.errVcode = true;
              return;
            }
            this.countDown();
            const params = {
              phone: this.ruleForm.phone,
            };
            const res = await get(obtainUrl('url_code'), params).catch(() => {
              message.error('验证码发送失败');
              this.errlg.addErrorPhone();
            });
            this.codeId = res;
            if (res) {
              message.success('验证码已发送');
              this.errlg.refreshPasWord(0);
            }
          }
        });
      }, 100);
    },
    // 隐私政策和服务协议接口
    tickProtocol() {
      if (!isCustomerSaasPrivate() && this.logoUi.appId === '10016') {
        post(api.agreementRecord, {
          phone: this.ruleForm.phone,
          agreementTitle: '隐私政策,用户服务协议',
        });
      }
    },
    /// 登录操作
    submitForm() {
      pointTools.traceClick({
        event_type: 'web_click',
        content: {
          event_id: 'page_login_clk',
          event_name: '登录页登录按钮',
        },
      });
      traceClick(
        {
          event_type: "web_click",
          content: {
            event_id: "auth_login_phonenumber_vcode_click",
            event_name: "登录 - 手机号验证码",
          },
        },
        true
      );
      if (this.agree != true) {
        message.error("请勾选确认已经阅读并同意以下协议!");
        return;
      }
      this.isLogin = true;
      setTimeout(() => {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (this.codeId === '') {
              message.error('请先获取验证码');
              return;
            }
            rmToken(); // 清除 token
            this.btnLoading = true;
            let params = {
              phone : await pwdPublicKeyEncode(this.ruleForm.phone),
              verifyCode : await pwdPublicKeyEncode(this.ruleForm.captcha),
              codeId: this.codeId,
            };
            const loginRes = await post(obtainUrl('url_sms'), params).catch(() => {
              // message.error('登录失败');
            });
            this.btnLoading = false;
            // if (loginRes && loginRes.token && loginRes.name) {
            if (loginRes && loginRes.token) {
              message.success('登录成功');
              // 获取用户信息需要token 所以先对登录信息进行缓存
              setToken(loginRes);
              this.tickProtocol();
              this.$emit('getLoginAccount', loginRes);
            }
          }
        });
      }, 100);
    },
  },
};
</script>
<style lang="less" >
.ant-btn:focus {
  box-shadow: none;
  border: 0 none;
  outline: none;
}
</style>
